"use client";

import React from "react";
import { ArrowRight, Clock, Leaf, TrendingUp, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  icon: Leaf,
  metric: "4+ år",
  title: "Branscherfarenhet",
  description: "Lång erfarenhet av ekonomisk rådgivning och redovisning."
}, {
  icon: TrendingUp,
  metric: "10+",
  title: "Nöjda Kunder",
  description: "Vi växer tillsammans med våra lokala samarbetspartners."
}, {
  icon: Clock,
  metric: "100%",
  title: "Digitalt Fokus",
  description: "Effektiva och moderna system för ett papperslöst flöde."
}, {
  icon: Users,
  metric: "Personligt",
  title: "Nära Kontakt",
  description: "Flexibla lösningar anpassade efter ditt företags behov."
}];
export default function FeatureHighlight() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="178785" id="sidebar" className="bg-background overflow-hidden text-foreground ![padding:60px_0px_128px_0px]">
      <div ref={ref} className={cn("max-w-7xl mx-auto px-6 lg:px-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col items-start">
            <Badge variant="default" className="rounded-sm uppercase tracking-wider mb-8 font-semibold bg-primary text-primary-foreground">
              Logik & Precision
            </Badge>
            
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-foreground">
              Trygg redovisning, <br className="hidden md:block" />
              <span className="text-primary">helt utan krångel.</span>
            </h2>
            
            <p className="text-lg text-foreground/80 mb-12 max-w-xl leading-relaxed font-sans">
              Logik Ekonomi erbjuder personlig rådgivning och digitala lösningar som ger dig full kontroll. Vi sköter siffrorna och de administrativa processerna så att du kan fokusera på att driva ditt företag framåt.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10 mb-12 w-full">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <div key={i} data-index={i} className="flex flex-col gap-3">
                    <Icon className="text-accent size-8" strokeWidth={1.5} />
                    <span className="text-4xl font-default font-bold text-foreground tracking-tight">
                      {feature.metric}
                    </span>
                    <div>
                      <h3 className="font-default font-bold text-foreground text-lg mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                        {feature.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
            
            <Button asChild size="lg" className="rounded-sm px-8 h-14 text-base bg-accent hover:bg-accent/90 text-accent-foreground shadow-lg shadow-accent/10 transition-all">
              <Link to="#">
                Se vårt erbjudande
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>

          {}
          <div className="relative w-full max-w-xl mx-auto lg:max-w-none">
            {}
            <div className="absolute inset-0 bg-primary/5 blur-3xl rounded-full transform -translate-x-1/4 translate-y-1/4" />
            
            <Card className="relative overflow-hidden shadow-xl shadow-black/5 border-border bg-card rounded-sm flex flex-col gap-0 p-0">
              <AspectRatio ratio={4 / 3} className="bg-muted">
                <img src="https://logikekonomi.se/wp-content/uploads/2026/04/ChatGPT-Image-Apr-10-2026-at-11_47_02-AM.png" alt="Logik Ekonomi Digital Dashboard" className="object-cover w-full h-full" />
              </AspectRatio>
              
              
            </Card>
          </div>

        </div>
      </div>
    </section>;
}